import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Agenda/addAgenda`, method: 'POST', body: values, token: token})
}
